import { FC, ReactNode } from 'react';
import './index.scss';

interface AccordionProps {
    children: ReactNode;
}

export const Accordion: FC<AccordionProps> = ({ children }) => {
    return <div className="accordion">{children}</div>;
};
